// World-event annotations for the archive timeline (a second lane below the
// presidential ribbon). Kept in its own non-component module (fast-refresh).
//
// Curation rules: globally recognizable, NON-partisan (natural disasters,
// economic, public-health, infrastructure), and within the index coverage
// (2007-01 → 2026-05, so e.g. Hurricane Katrina (2005) is intentionally
// omitted — it'd fall off the left edge). `end` present ⇒ a span, else a
// point. Edit freely; the chart clips/skips anything outside coverage.

export interface WorldEvent {
  label: string;
  date: string; // "YYYY-MM"
  end?: string; // present ⇒ a span
}

export const WORLD_EVENTS: WorldEvent[] = [
  { label: "Financial crisis", date: "2008-09" },
  { label: "Deepwater Horizon", date: "2010-04" },
  { label: "European Debt Crisis", date: "2010-04", end: "2015-08" },
  { label: "Chilean miners rescue", date: "2010-10" },
  { label: "Fukushima", date: "2011-03" },
  { label: "Hurricane Sandy", date: "2012-10" },
  { label: "Pluto flyby", date: "2015-07" },
  { label: "US solar eclipse", date: "2017-08" },
  { label: "Notre-Dame fire", date: "2019-04" },
  { label: "COVID-19", date: "2020-03", end: "2023-05" },
  { label: "Suez blockage", date: "2021-03" },
  { label: "Queen Elizabeth II dies", date: "2022-09" },
  { label: "Paris Olympics", date: "2024-07" },
];
